exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".edit-view .el-form-item[data-v-644260e9]{margin-bottom:0}", "", {"version":3,"sources":["/app/src/components/Submission/steps/CollaboratorDetails/CollaboratorItem/EditView.vue"],"names":[],"mappings":"AACA,0CACE,eAAiB,CAClB","file":"EditView.vue","sourcesContent":["\n.edit-view .el-form-item[data-v-644260e9] {\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-644260e9","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Submission/steps/CollaboratorDetails/CollaboratorItem/EditView.vue
// module id = 556
// module chunks = 0 1 2 3 9